import {gsap, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class TextAppear {
	static init() {

		document.fonts.ready.then(() => {

			const items = document.querySelectorAll("[data-text-appear]");
			const items2 = document.querySelectorAll("[data-text-reveal]");

			this.splitTexts = [];

			items.forEach(elem => {
				const innerSplit = new SplitText(elem, {
					type: "lines",
					linesClass: "split-inner"
				});

				const outerSplit = new SplitText(elem, {
					type: "lines",
					linesClass: "split-outer"
				});
				this.splitTexts.push(outerSplit);
				this.splitTexts.push(innerSplit);

				const delay = elem.dataset.textAppearDelay ?? 0; // Utilisez l'attribut HTML `data-aos-delay`

				const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: elem,
						start: "top 90%",
					},
				});

				splitTimeline.set(elem, {
					visibility: 'visible'
				});

				splitTimeline.from(innerSplit.lines, {
					delay: parseFloat(delay),
					duration: 1,
					yPercent: 150,
					ease: "power1.ease",
					stagger: 0.15,
					autoAlpha: 0
				});
			});

			items2.forEach(elem => {
				elem.innerHTML = elem.innerHTML.replaceAll('-', '<span>-</span>');
				let split, tl;

				const createSplit = () => {
					split && split.revert();
					tl && tl.revert();
					split = new SplitText(elem, {
						type: "chars,words",
						charsClass: "char"
					});

					tl = gsap
						.timeline({
							scrollTrigger: {
								trigger: elem,
								start: "top 80%",
								end: "bottom center",
								scrub: 0.75,
							}
						})
						.to( split.chars,
							{
								opacity: 1,
								stagger: 0.1,
								duration: 2,
							},
							0.1
						);
				};
				createSplit();
				//const debouncer = gsap.delayedCall(0.2, createSplit).pause();

				//window.addEventListener("resize", () => debouncer.restart(true));
			});

			GlobalVariables.resizeCallbacks.push(this);

		});

	}



	static resize() {
		this.splitTexts.forEach(item => {
			item.revert();
		});
	}
}
